import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '../context/ThemeContext';
import { useLanguage } from '../context/LanguageContext';
import './Navbar.css';

const links = [
  { to: '/', key: 'nav_home' },
  { to: '/services', key: 'nav_services' },
  { to: '/gallery', key: 'nav_gallery' },
  { to: '/about', key: 'nav_about' },
  { to: '/contact', key: 'nav_contact' }
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();
  const { lang, toggleLanguage, t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 40);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Ferme le menu à chaque changement de page
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  // Menu mobile ouvert : on bloque le défilement de la page et on écoute Échap
  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => e.key === 'Escape' && setIsOpen(false);
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [isOpen]);

  // Toutes les pages commencent par une photo : la barre est transparente
  // au-dessus, puis devient pleine dès qu'on défile.
  const solid = isScrolled || isOpen;

  const controls = (
    <>
      <button
        className="nav-icon-btn"
        onClick={toggleTheme}
        aria-label={theme === 'light' ? 'Mode sombre' : 'Mode clair'}
      >
        <FontAwesomeIcon icon={theme === 'light' ? faMoon : faSun} />
      </button>
      <button className="nav-icon-btn nav-lang-btn" onClick={toggleLanguage} aria-label="Changer de langue">
        {lang === 'fr' ? 'EN' : 'FR'}
      </button>
    </>
  );

  return (
    <header className={`navbar ${solid ? 'is-solid' : 'is-transparent'}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" aria-label="Senegalaise Deco Meuble - Accueil">
          <img src="/img/logo.webp" alt="" width="44" height="44" className="logo-img" />
          <span className="logo-text">
            <span className="logo-name">Senegalaise Deco Meuble</span>
            <span className="logo-tagline">Menuiserie · Mbour</span>
          </span>
        </Link>

        <nav className={`nav-menu ${isOpen ? 'open' : ''}`} id="menu-principal">
          <ul className="nav-links">
            {links.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className={`nav-link ${location.pathname === link.to ? 'active' : ''}`}
                  aria-current={location.pathname === link.to ? 'page' : undefined}
                >
                  {t(link.key)}
                </Link>
              </li>
            ))}
          </ul>
          <div className="nav-actions">
            {controls}
            <Link to="/contact" className="btn btn-primary nav-cta">
              {t('nav_quote_btn')}
            </Link>
          </div>
        </nav>

        <button
          className="nav-icon-btn menu-toggle"
          onClick={() => setIsOpen(!isOpen)}
          aria-expanded={isOpen}
          aria-controls="menu-principal"
          aria-label={isOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
        >
          <FontAwesomeIcon icon={isOpen ? faTimes : faBars} />
        </button>
      </div>
    </header>
  );
};

export default Navbar;
